import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { h2, link, tickedBullet } from '@helpers/typography';
import TickCircleOrange from '@img/icons/tick-circle-orange.svg?url';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled.div `
  padding: ${fluid(34, 40)} ${fluid(18, 30)} ${fluid(23, 63)};
  box-shadow: 0 0 6px ${rgba(brand.black, 0.16)};
`;
const Heading = styled.h2 `
  ${h2};
`;
const Content = styled.div `
  ${tickedBullet};

  ul {
    li {
      &::before {
        background-image: url(${TickCircleOrange});
      }
    }
  }

  a {
    ${link};
    color: ${brand.orange};
  }
`;
export const USPCardStyles = {
    Container,
    Content,
    Heading,
};
